import styled from 'styled-components';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { PimImage } from 'src/components/common/PimImage';
import { LinkedProductDTO } from 'src/models/pim';
import { route } from 'src/services/route';
import { TrackedLink } from 'src/components/TrackedLink';

export type ProductPageRelatedItemProps = LinkedProductDTO;

const Container = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 40px 24px;

  width: 250px;
  height: 370px;

  background: ${({ theme }) => theme.palette.background};
  border: 2px solid transparent;
  transition: 0.35s;

  &:hover {
    border-color: ${({ theme }) => theme.buttons.default.primary.hover.accent};
  }
`;

const Name = styled.h5`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 8px;
  margin-top: auto;

  color: ${({ theme }) => theme.text.palette.primary};
`;

const ImageContainer = styled.div`
  position: relative;
  width: 200px;
  height: 220px;
  object-fit: contain;
`;

export const ProductPageRelatedItem = (_item: ProductPageRelatedItemProps) => {
  const item = useTranslateItem(_item);

  return (
    <TrackedLink href={route.products().page(item)} passHref>
      <Container>
        <ImageContainer>
          {item.image && (
            <PimImage
              src={item.image.id}
              width={200}
              height={220}
              objectFit="contain"
              sizes="100vw"
            />
          )}
        </ImageContainer>

        <Name>{item.name}</Name>
      </Container>
    </TrackedLink>
  );
};
